import {Component, Event, EventEmitter, h, Host, Listen, Prop, State} from "@stencil/core";

import {_debug} from "../../common/debugger/debugger";
import {replaceText} from "../../common/i18n-util";

@Component({
    tag: "lb-uploads",
    shadow: true,
})

export class LBUploads {

    @Prop({ reflect: true, mutable: true }) i18n

    @Prop({ reflect: true, mutable: true }) refreshurl
    @Prop({ reflect: true, mutable: true }) sessionexpiry = 30000
    @Prop({ reflect: true, mutable: true }) showexpiryinfos = true

    // collect document id's on file upload
    @State() documentIDs
    @Listen("filesUploaded", {target: 'document'}) handleFilesUploaded(ev) {
        this.documentIDs = ev.detail
    }

    // send document ids which should not be deleted
    sendUploadInfos() {
        if (!this.documentIDs) return
        fetch(this.refreshurl, {
            method: "PUT",
            headers: {
                "X-CSRF-TOKEN": "true",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({documentIds: this.documentIDs})
        }).then(()=> {
            this._busy = false
        });
    }

    @Event() uploadsexpired: EventEmitter;

    // handle remaining time
    @State() _timeUntilExpiration
    @State() uploadSessionExpired: boolean = false

    handlePrompt(remainingTime) {
        _debug('in handle Prompt')
        if (this.uploadSessionExpired) return
        
        if (!this._busy) {
            this._timeUntilExpiration = remainingTime
        }
            
        if(remainingTime < 0) {
            this.idleTimer?.shutDown()
            this.uploadSessionExpired = true
            this.uploadsexpired.emit()
        }
    }

    idleTimer
    _busy
    handleActivity() {
        if (this.uploadSessionExpired) return

        _debug('lb uploads in handle Activity')
        this._busy = true;
        this._timeUntilExpiration = undefined
        this.idleTimer?.reset()
        if(!this.uploadSessionExpired) {
            this.sendUploadInfos()
        }
    }

    formattedMilliseconds(milliseconds) { // ToDo use date/time formatting libraries as soon as i18n is established
        const minutesToExpiration = Math.ceil((milliseconds / 1000 / 60) << 0)
        const secondsToExpiration = Math.floor((milliseconds / 1000) << 0)

        const formatted = minutesToExpiration !== 0 ?
        (minutesToExpiration === 1 ? (minutesToExpiration + ' ' + this.i18n?.timeUnitMinute) 
        : (minutesToExpiration + ' ' + this.i18n?.timeUnitMinutes)) 
        : secondsToExpiration + ' ' + this.i18n?.timeUnitSeconds;

        return ' ' + formatted
    }

    render() {
        const toastStyles = {
            'position': 'fixed',
            'bottom': '10px',
            'right': '20%',
            'left': '10%',
            'width': 'auto',
            'padding': '16px',
            'color': '#000',
            'background-color': '#F6C47E',
            'border-radius': '4px',
            'box-shadow': '0 3px 8px rgba(0, 0, 0, 0.4)'
        }

        return (
            <Host>
            {  this.documentIDs && this.documentIDs.length > 0 &&
                <lb-idle-timer 
                    ref={(el) => this.idleTimer = el as HTMLLbIdleTimerElement}
                    idleThresholdMs={ this.sessionexpiry }
                    onActivity={() => this.handleActivity()} 
                    onPrompt={({detail}) => this.handlePrompt(detail)} />
            }      
            {
                this.showexpiryinfos && this._timeUntilExpiration && this._timeUntilExpiration > 0 &&
                    <div style={ toastStyles } slot="content">
                        <muse-text variant="font-heading-xs" data-testid="session-warning-title">
                           {replaceText(this.i18n?.sessionExpirationHeadline, 'sessionRemainingTime', this.formattedMilliseconds(this._timeUntilExpiration))}
                        </muse-text>
                        <br />
                        <br />
                        <muse-text>
                            {replaceText(this.i18n?.sessionExpirationText, 'sessionExtensionTime', this.formattedMilliseconds(this.sessionexpiry))}
                        </muse-text>
                    </div>
            }
            {
              this.showexpiryinfos && this.uploadSessionExpired &&
                  <muse-dialog open>
                      <span slot="heading">{ this.i18n?.sessionTerminationHeadline }</span>
                      <muse-text variant="font-body-lg">
                          { this.i18n?.sessionTerminationText }
                      </muse-text>

                      <muse-button slot="action" variant="primary"
                        onClick={() => {
                          this.uploadSessionExpired = false;
                          location.reload();
                        }
                      }
                      >
                        {this.i18n?.formularReloadBtn}
                      </muse-button>
                  </muse-dialog>
            }
        </Host>    
        )
    }
}
